// extracted by mini-css-extract-plugin
module.exports = {"limitReminder":"index-module_limitReminder_3lspv","contentIcon":"index-module_contentIcon_13BaG","contentText":"index-module_contentText_2mRzc"};